import { Component } from '@angular/core';
import {
    ResetPasswordComponent
} from '@capturum/login';
@Component({
  selector: 'app-custom-reset-password',
  templateUrl: './custom-reset-password.component.html',
  styleUrls: ['./custom-reset-password.component.scss']
})
export class CustomResetPasswordComponent extends ResetPasswordComponent {

}
